import NavigationOutlinedIcon from '@mui/icons-material/NavigationOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import ChromeReaderModeOutlinedIcon from '@mui/icons-material/ChromeReaderModeOutlined';
import SecurityOutlinedIcon from '@mui/icons-material/SecurityOutlined';
import ContactSupportOutlinedIcon from '@mui/icons-material/ContactSupportOutlined';
import GavelOutlinedIcon from '@mui/icons-material/GavelOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined'; 
import EngineeringOutlinedIcon from '@mui/icons-material/EngineeringOutlined'; 
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined'; 
import BusinessIcon from '@mui/icons-material/Business';
import DriveEtaIcon from '@mui/icons-material/DriveEta';
import WorkIcon from '@mui/icons-material/Work';
import PoolIcon from '@mui/icons-material/Pool';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ApartmentIcon from '@mui/icons-material/Apartment';
import PlaceIcon from '@mui/icons-material/Place';
import MapIcon from '@mui/icons-material/Map';
import PublicIcon from '@mui/icons-material/Public';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import RouteIcon from '@mui/icons-material/Route';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import InventoryIcon from '@mui/icons-material/Inventory';
import CategoryIcon from '@mui/icons-material/Category';
import PriceChangeIcon from '@mui/icons-material/PriceChange';
import ReceiptIcon from '@mui/icons-material/Receipt';
import ListAltIcon from '@mui/icons-material/ListAlt';
import ArchiveIcon from '@mui/icons-material/Archive';
import DescriptionIcon from '@mui/icons-material/Description';
import CampaignIcon from '@mui/icons-material/Campaign';
import EditIcon from '@mui/icons-material/Edit';
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import ImageIcon from '@mui/icons-material/Image';
import StarIcon from '@mui/icons-material/Star';
import PeopleIcon from '@mui/icons-material/People';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined'; 
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import { 
  School as AcademyIcon, 
  MenuBook as CourseIcon, 
  TrendingUp as ProgressIcon, 
  WorkspacePremium as CertificateIcon,
  FolderOpenOutlined as FolderOpenOutlinedIcon,
  DescriptionOutlined as DescriptionOutlinedIcon,
  InventoryOutlined as InventoryOutlinedIcon,
  CategoryOutlined as CategoryOutlinedIcon,
  ApartmentOutlined as ApartmentOutlinedIcon,
  WorkOutlineOutlined as WorkOutlineOutlinedIcon,
  TrendingUpOutlined as TrendingUpOutlinedIcon,
  BusinessCenterOutlined as BusinessCenterOutlinedIcon,
  Assignment as AssignmentIcon,
  Group as GroupIcon,
  HealthAndSafety as HealthAndSafetyIcon,
  TrendingUp as TrendingUpIcon,
  TrendingDown as TrendingDownIcon,
  SwapHoriz as SwapHorizIcon,
  AttachMoney as AttachMoneyIcon,
  PersonAdd as PersonAddIcon,
  Schedule as ScheduleIcon,
  Cancel as CancelIcon,
  EventAvailable as EventAvailableIcon,
  FlightTakeoff as FlightTakeoffIcon,
  MeetingRoom as MeetingRoomIcon,
  PersonOff as PersonOffIcon,
  EventBusy as EventBusyIcon,
  School as SchoolIcon,
  ExitToApp as ExitToAppIcon,
  PersonRemove as PersonRemoveIcon,
  ThumbUp as ThumbUpIcon,
  VpnKey as VpnKeyIcon,
  Person as PersonIcon,
  AccessTime as AccessTimeIcon,
  Payment as PaymentIcon,
  Assessment as AssessmentIcon,
  Settings as SettingsIcon,
  Dashboard as DashboardIcon
} from '@mui/icons-material';
import HistoryIcon from '@mui/icons-material/History';
import MenuBookIcon from '@mui/icons-material/MenuBook';

const icons = {
  NavigationOutlinedIcon,
  TrendingUpOutlinedIcon,
  BusinessCenterOutlinedIcon,
  FolderOpenOutlinedIcon,
  InventoryOutlinedIcon,
  DescriptionOutlinedIcon,
  CategoryOutlinedIcon,
  ApartmentOutlinedIcon,
  WorkOutlineOutlinedIcon,
  AcademyIcon,
  CourseIcon,
  ProgressIcon,
  CertificateIcon,
  InsertDriveFileOutlinedIcon,
  ArticleOutlinedIcon,
  HomeOutlinedIcon,
  ChromeReaderModeOutlinedIcon,
  SecurityOutlinedIcon,
  ContactSupportOutlinedIcon,
  GavelOutlinedIcon,
  BusinessOutlinedIcon,
  EngineeringOutlinedIcon,
  LocalShippingOutlinedIcon,
  BusinessIcon,
  DriveEtaIcon,
  WorkIcon,
  PoolIcon,
  AccountBoxIcon,
  LocationOnIcon,
  ApartmentIcon,
  PlaceIcon,
  MapIcon,
  PublicIcon,
  LocationCityIcon,
  RouteIcon,
  AssignmentTurnedInIcon,
  InventoryIcon,
  CategoryIcon,
  PriceChangeIcon,
  ReceiptIcon,
  ListAltIcon,
  ArchiveIcon,
  DescriptionIcon,
  CampaignIcon,
  EditIcon,
  PermIdentityIcon,
  ImageIcon,
  StarIcon,
  PeopleIcon,
  ReceiptLongIcon,
  WorkspacePremiumIcon,
  AssignmentIcon,
  GroupIcon,
  HealthAndSafetyIcon,
  TrendingUpIcon,
  TrendingDownIcon,
  SwapHorizIcon,
  AttachMoneyIcon,
  PersonAddIcon,
  ScheduleIcon,
  CancelIcon,
  EventAvailableIcon,
  FlightTakeoffIcon,
  MeetingRoomIcon,
  PersonOffIcon,
  EventBusyIcon,
  SchoolIcon,
  ExitToAppIcon,
  PersonRemoveIcon,
  ThumbUpIcon,
  VpnKeyIcon,
  PersonIcon,
  AccessTimeIcon,
  PaymentIcon,
  AssessmentIcon,
  SettingsIcon,
  DashboardIcon
  ,
  HistoryIcon,
  MenuBookIcon
};

export default {
  items: [
    {
      id: 'navigation',
      title: 'Eureka Group',
      caption: 'Dashboard',
      type: 'group',
      icon: icons.NavigationOutlinedIcon,
      allowedRoles: ['user', 'admin', 'superadmin'],
      children: [
        {
          id: 'dashboard',
          title: 'Dashboard',
          type: 'item',
          icon: icons.HomeOutlinedIcon,
          url: '/dashboard'
        },
        {
          id: 'overview',
          title: 'Overview',
          type: 'item',
          icon: icons.DashboardIcon,
          url: '/overview',
          allowedRoles: ['superadmin', 'admin']
        },
        // KONTAK MENU
        {
          id: 'Rekrutmen & Onboarding',
          title: 'Rekrutmen & Onboarding',
          type: 'collapse',
          icon: icons.ContactSupportOutlinedIcon,
          allowedRoles: ['admin', 'superadmin'],
          children: [
            // {
            //   id: 'customer',
            //   title: 'Customer',
            //   type: 'item',
            //   icon: icons.ContactSupportOutlinedIcon,
            //   url: '/kontak/customer'
            // },
            {
              id: 'candidate',
              title: 'Candidate',
              type: 'item',
              icon: icons.ContactSupportOutlinedIcon,
              url: '/kontak/candidate'
            },
            // {
            //   id: 'vendor',
            //   title: 'Vendor',
            //   type: 'item',
            //   icon: icons.BusinessOutlinedIcon,
            //   url: '/kontak/vendor' 
            // },
            {
              id: 'employee',
              title: 'Employee',
              type: 'item',
              icon: icons.EngineeringOutlinedIcon,
              url: '/kontak/employee' // Assuming you want to add a URL for navigation
            },
            {
              id: 'document',
              title: 'Document',
              type: 'item',
              url: '/document',
              icon: icons.DescriptionOutlinedIcon, // Ikon untuk "Document"
            },
            // {
            //   id: 'supplier',
            //   title: 'Supplier',
            //   type: 'item',
            //   icon: icons.LocalShippingOutlinedIcon,
            //   url: '/kontak/supplier' // Keeping the original URL for Supplier
            //             }
          ]
        },
        // SSO MANAGEMENT MENU
        {
          id: 'sso-management',
          title: 'SSO Management',
          type: 'collapse',
          icon: icons.VpnKeyIcon,
          allowedRoles: ['superadmin'],
          children: [
            {
              id: 'sso-client',
              title: 'Client SSO',
              type: 'item',
              icon: icons.BusinessIcon,
              url: '/sso/client'
            },
            {
              id: 'sso-user',
              title: 'User SSO',
              type: 'item',
              icon: icons.PersonIcon,
              url: '/sso/user'
            },
            {
              id: 'sso-user-role',
              title: 'User Role',
              type: 'item',
              icon: icons.VpnKeyIcon,
              url: '/sso/user-role'
            },
          ]
        },
        {
          id: 'pelatihan-management',
          title: 'Kepelatihan',
          type: 'collapse',
          icon: icons.SchoolIcon,
          allowedRoles: ['superadmin'],
          children: [
            {
              id: 'training-history',
              title: 'History Pelatihan',
              type: 'item',
              icon: icons.HistoryIcon || icons.MenuBookIcon,
                  url: '/pelatihan/history'
            },
            {
              id: 'training-catalog',
              title: 'Pilihan Pelatihan & Vendor',
              type: 'item',
              icon: icons.PeopleIcon,
                  url: '/pelatihan/catalog'
            },
            {
              id: 'training-curriculum',
              title: 'Kurikulum',
              type: 'item',
              icon: icons.MenuBookIcon,
                  url: '/pelatihan/kurikulum'
            }
          ]
        },
        // MEETING (top-level, placed below Kepelatihan)
        {
          id: 'meeting',
          title: 'Meeting',
          type: 'item',
          icon: icons.MeetingRoomIcon,
          url: '/kontak/meeting',
          allowedRoles: ['user', 'admin', 'superadmin']
        },
        
        // FORM PENGAJUAN MENU
        {
          id: 'form-pengajuan',
          title: 'Form Pengajuan',
          type: 'collapse',
          icon: icons.AssignmentIcon,
          allowedRoles: ['user', 'admin', 'superadmin'],
          children: [
            {
              id: 'permintaan-sdm',
              title: 'Permintaan SDM',
              type: 'item',
              icon: icons.GroupIcon,
              url: '/form-pengajuan/permintaan-sdm'
            },
            {
              id: 'kesehatan',
              title: 'Kesehatan',
              type: 'item',
              icon: icons.HealthAndSafetyIcon,
              url: '/form-pengajuan/kesehatan'
            },
            {
              id: 'promosi',
              title: 'Promosi',
              type: 'item',
              icon: icons.TrendingUpIcon,
              url: '/form-pengajuan/promosi'
            },
            {
              id: 'demosi',
              title: 'Demosi',
              type: 'item',
              icon: icons.TrendingDownIcon,
              url: '/form-pengajuan/demosi'
            },
            {
              id: 'mutasi',
              title: 'Mutasi',
              type: 'item',
              icon: icons.SwapHorizIcon,
              url: '/form-pengajuan/mutasi'
            },
            {
              id: 'kenaikan-gaji',
              title: 'Kenaikan Gaji',
              type: 'item',
              icon: icons.AttachMoneyIcon,
              url: '/form-pengajuan/kenaikan-gaji'
            },
            {
              id: 'pengangkatan',
              title: 'Pengangkatan',
              type: 'item',
              icon: icons.PersonAddIcon,
              url: '/form-pengajuan/pengangkatan'
            },
            {
              id: 'perpanjangan-kontrak',
              title: 'Perpanjangan Kontrak',
              type: 'item',
              icon: icons.ScheduleIcon,
              url: '/form-pengajuan/perpanjangan-kontrak'
            },
            {
              id: 'pemutusan-kontrak',
              title: 'Pemutusan Kontrak',
              type: 'item',
              icon: icons.CancelIcon,
              url: '/form-pengajuan/pemutusan-kontrak'
            },
            {
              id: 'cuti',
              title: 'Cuti',
              type: 'item',
              icon: icons.EventAvailableIcon,
              url: '/form-pengajuan/cuti'
            },
            {
              id: 'perjalanan-dinas',
              title: 'Perjalanan Dinas',
              type: 'item',
              icon: icons.FlightTakeoffIcon,
              url: '/form-pengajuan/perjalanan-dinas'
            },
            {
              id: 'perjalanan-dinas-training',
              title: 'Perjalanan Dinas Training/Meeting',
              type: 'item',
              icon: icons.MeetingRoomIcon,
              url: '/form-pengajuan/perjalanan-dinas-training'
            },
            {
              id: 'keterangan-tidak-absen',
              title: 'Keterangan Tidak Absen',
              type: 'item',
              icon: icons.PersonOffIcon,
              url: '/form-pengajuan/keterangan-tidak-absen'
            },
            {
              id: 'izin-tidak-masuk',
              title: 'Izin Tidak Masuk',
              type: 'item',
              icon: icons.EventBusyIcon,
              url: '/form-pengajuan/izin-tidak-masuk'
            },
            {
              id: 'pelatihan',
              title: 'Pelatihan',
              type: 'item',
              icon: icons.SchoolIcon,
              url: '/form-pengajuan/pelatihan'
            },
            {
              id: 'pengunduran-diri',
              title: 'Pengunduran Diri',
              type: 'item',
              icon: icons.ExitToAppIcon,
              url: '/form-pengajuan/pengunduran-diri'
            },
            {
              id: 'phk-pensiun',
              title: 'PHK / Pensiun',
              type: 'item',
              icon: icons.PersonRemoveIcon,
              url: '/form-pengajuan/phk-pensiun'
            },
            {
              id: 'rekomendasi-karyawan-keluar',
              title: 'Rekomendasi Karyawan Keluar',
              type: 'item',
              icon: icons.ThumbUpIcon,
              url: '/form-pengajuan/rekomendasi-karyawan-keluar'
            }
          ]
        },
        // ABSENSI MENU
        {
          id: 'absensi',
          title: 'Absensi',
          type: 'item',
          icon: icons.AccessTimeIcon,
          url: '/absensi',
          allowedRoles: ['user', 'admin', 'superadmin']
        },
        // PAYROLL MENU
        {
          id: 'payroll',
          title: 'Payroll',
          type: 'item',
          icon: icons.PaymentIcon,
          url: '/payroll',
          allowedRoles: ['admin', 'superadmin']
        },
        // PENILAIAN KINERJA MENU
        {
          id: 'penilaian-kinerja',
          title: 'Penilaian Kinerja',
          type: 'item',
          icon: icons.AssessmentIcon,
          url: '/penilaian-kinerja',
          allowedRoles: ['admin', 'superadmin']
        },
        // SELF-SERVICE MENU
        {
          id: 'self-service',
          title: 'Self-service',
          type: 'item',
          icon: icons.SettingsIcon,
          url: '/self-service',
          allowedRoles: ['user', 'admin', 'superadmin']
        },
        // EUREKA PLUS MENU
        {
          id: 'eureka-plus',
          title: 'EUREKA PLUS',
          type: 'collapse',
          icon: icons.WorkspacePremiumIcon,
          allowedRoles: ['admin', 'superadmin'],
          children: [
            {
              id: 'external-customers',
              title: 'External Customers',
              type: 'item',
              icon: icons.PeopleIcon,
              url: '/eureka-plus/external-customers'
            },
            {
              id: 'external-transactions',
              title: 'External Transactions',
              type: 'item',
              icon: icons.ReceiptLongIcon,
              url: '/eureka-plus/external-transactions'
            }
          ]
        },
        // LAIN-LAIN MENU (Master, Company Profile, Academy)
        {
          id: 'lain-lain',
          title: 'Lain-lain',
          type: 'collapse',
          icon: icons['BusinessIcon'],
          allowedRoles: ['superadmin'],
          children: [
            // MASTER SUBMENU
            {
              id: 'master',
              title: 'MASTER',
              type: 'collapse',
              icon: icons['BusinessIcon'],
              allowedRoles: ['superadmin'],
              children: [
                {
                  id: 'bu',
                  title: 'BU',
                  type: 'item',
                  url: '/master/bu',
                  icon: icons['BusinessIcon'],
                  breadcrumbs: false
                },
                {
                  id: 'vehicle',
                  title: 'Vehicle',
                  type: 'item', 
                  icon: icons['DriveEtaIcon'], 
                  url: '/master/vehicle' 
                },
                {
                  id: 'pool',
                  title: 'Pool',
                  type: 'item',
                  url: '/master/pool',
                  icon: icons['PoolIcon']
                },
                {
                  id: 'driver',
                  title: 'Driver',
                  type: 'item',
                  url: '/master/driver',
                  icon: icons['DriveEtaIcon']
                },
                {
                  id: 'employee-position',
                  title: 'Employee Position',
                  type: 'item',
                  url: '/master/employee-position',
                  icon: icons['AccountBoxIcon']
                }
              ]
            },
            // COMPANY PROFILE SUBMENU
            {
              id: 'marketing',
              title: 'COMPANY PROFILE',
              type: 'collapse', 
              icon: icons.CampaignIcon,
              allowedRoles: ['superadmin'],
              children: [
                {
                  id: 'StudyCase',
                  title: 'Study Case',
                  type: 'item',
                  url: '/compro/study-case',
                  icon: icons.CampaignIcon
                },
                {
                  id: 'blog-post',
                  title: 'Blog Post',
                  type: 'item',
                  icon: icons.EditIcon,
                  url: '/compro/blog-post',
                },
                {
                  id: 'Bisnis-Unit-Management',
                  title: 'BU Management',
                  type: 'item',
                  icon: icons['AccountBoxIcon'],
                  url: '/compro/Bisnis-Unit-Management',
                },
                {
                  id: 'Bisnis-Unit-Detail',
                  title: 'BU Detail',
                  type: 'item',
                  url: '/compro/Bisnis-Unit-Detail',
                  icon: icons.ImageIcon
                },
                {
                  id: 'blog-author',
                  title: 'Author',
                  type: 'item',
                  url: '/compro/author',
                  icon: icons.PermIdentityIcon
                },
                {
                  id: 'promo',
                  title: 'Promo',
                  type: 'item',
                  url: '/compro/promo',
                  icon: icons.StarIcon
                },
                {
                  id: 'career',
                  title: 'Career',
                  type: 'item',
                  url: '/compro/career',
                  icon: icons.WorkIcon 
                }
              ]
            },
            // ACADEMY SUBMENU
            {
              id: 'academy',
              title: 'ACADEMY',
              type: 'collapse',
              icon: AcademyIcon,
              allowedRoles: ['superadmin'],
              children: [
                {
                  id: 'course-category',
                  title: 'Kategori Kursus',
                  type: 'item',
                  url: '/academy/course-category',
                  icon: CategoryIcon,
                },
                {
                  id: 'courses',
                  title: 'Kursus',
                  type: 'item',
                  url: '/academy/courses',
                  icon: CourseIcon,
                },
                {
                  id: 'courses-detail',
                  title: 'Kursus-Details',
                  type: 'item',
                  url: '/academy/course-details',
                  icon: CourseIcon,
                },
                {
                  id: 'quiz',
                  title: 'quiz',
                  type: 'item',
                  url: '/academy/course-quiz',
                  icon: CourseIcon,
                },
                {
                  id: 'quizOP',
                  title: 'quiz options',
                  type: 'item',
                  url: '/academy/course-quiz-options',
                  icon: CourseIcon,
                },
                {
                  id: 'view-progress',
                  title: 'Lihat Progress',
                  type: 'item',
                  url: '/academy/progress',
                  icon: ProgressIcon,
                },
                {
                  id: 'certificate',
                  title: 'Sertifikat',
                  type: 'item',
                  url: '/academy/certificate',
                  icon: CertificateIcon,
                },
              ],
            }
          ]
        },
        // WILAYAH MENU
        // {
        //   id: 'wilayah',
        //   title: 'Wilayah',
        //   type: 'collapse', // Change from 'group' to 'collapse'
        //   icon: icons.PlaceIcon,
        //   children: [
        //     {
        //       id: 'subdistrict',
        //       title: 'Subdistrict',
        //       type: 'item',
        //       url: '/wilayah/subdistrict',
        //       icon: icons.ApartmentIcon,
        //     },
        //     {
        //       id: 'city',
        //       title: 'City',
        //       type: 'item',
        //       url: '/wilayah/city',
        //       icon: icons.LocationCityIcon,
        //     },
        //     {
        //       id: 'province',
        //       title: 'Province',
        //       type: 'item',
        //       url: '/wilayah/province',
        //       icon: icons.MapIcon,
        //     },
        //   ],
        // },
        // LOGISTICS MENU
        {
          id: 'logistics',
          title: 'LOGISTICS',
          type: 'collapse',
          icon: icons.RouteIcon,
          allowedRoles: ['superadmin'],
          children: [
            {
              id: 'route',
              title: 'Route',
              type: 'item',
              url: '/logistics/route',
              icon: icons.RouteIcon,
            },
            {
              id: 'vehicle-timeline',
              title: 'Vehicle Timeline',
              type: 'item',
              url: '/logistics/vehicle-timeline',
              icon: icons.LocalShippingOutlinedIcon,
            },
          ]
        },
        // ORDER MENU
        // {
        //   id: 'order',
        //   title: 'ORDER',
        //   type: 'collapse', 
        //   icon: icons.ListAltIcon,
        //   children: [
        //     {
        //       id: 'order',
        //       title: 'Order',
        //       type: 'item',
        //       url: '/order',
        //       icon: icons.ListAltIcon,
        //       children: []
        //     },
        //     {
        //       id: 'order-status',
        //       title: 'Order Status',
        //       type: 'item',
        //       url: '/order/order-status',
        //       icon: icons.ArchiveIcon,
        //       children: []
        //     },
        //     {
        //       id: 'order-invoice',
        //       title: 'Order Invoice',
        //       type: 'item',
        //       url: '/order/order-invoice',
        //       icon: icons.DescriptionIcon,
        //       children: []
        //     },
        //     {
        //       id: 'lose',
        //       title: 'Lose Sales',
        //       type: 'item',
        //       url: '/order/lose-sales',
        //       icon: icons.InventoryIcon
        //     },
        //   ],
        // },
        // (Company Profile moved under Lain-lain)
        // DOCUMENT MENU
        {
          id: 'document',
          title: 'DOCUMENT',
          type: 'collapse', 
          icon: icons.FolderOpenOutlinedIcon, // Ikon untuk menu utama "Document"
          allowedRoles: ['superadmin'],
          children: [

            {
              id: 'Cabinet',
              title: 'Cabinet',
              type: 'item',
              url: '/document/cabinet',
              icon: icons.InventoryOutlinedIcon, // Ikon untuk "Cabinet"
            },
            {
              id: 'Document-Category',
              title: 'Document Category',
              type: 'item',
              url: '/document/document-category',
              icon: icons.CategoryOutlinedIcon, // Ikon untuk "Document Category"
            },
            {
              id: 'Department',
              title: 'Department',
              type: 'item',
              url: '/document/Department',
              icon: icons.ApartmentOutlinedIcon, // Ikon untuk "Department"
            },
            {
              id: 'Designation',
              title: 'Designation',
              type: 'item',
              url: '/document/Designation',
              icon: icons.WorkOutlineOutlinedIcon, // Ikon untuk "Designation"
            },
            {
              id: 'Office',
              title: 'Office',
              type: 'item',
              url: '/document/Office',
              icon: icons.BusinessOutlinedIcon, // Ikon untuk "Office"
            },
            {
              id: 'Joblevel',
              title: 'Job-Level',
              type: 'item',
              url: '/document/Job-level',
              icon: icons.TrendingUpOutlinedIcon, // Ikon untuk "Job-Level"
            },
            {
              id: 'JonLevelDesc',
              title: 'Job Level Description',
              type: 'item',
              url: '/document/Job-level-description',
              icon: icons.DescriptionOutlinedIcon, // Ikon untuk "Job Level Description"
            },
            {
              id: 'BisnisUnitDash',
              title: 'Bisnis-Unit',
              type: 'item',
              url: '/document/Bisnis-Unit',
              icon: icons.BusinessCenterOutlinedIcon, // Ikon untuk "Bisnis-Unit"
            },
          ]
        },
   
        // (Academy moved under Lain-lain)
      ]
    },
  ]
};
